import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LOGO_URL } from '@/lib/constants';
import { Lock, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#141413] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="TreffPunkt" className="h-20 w-auto mx-auto mb-4 object-contain" />
          <p className="text-stone-500 text-sm font-body">Admin-Zugang</p>
        </div>

        <form onSubmit={handleSubmit} className="glass-card rounded-2xl p-8 space-y-5" data-testid="login-form">
          <div>
            <label className="text-stone-400 text-xs font-body uppercase tracking-wider mb-1.5 block">E-Mail</label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@treffpunkt.ch"
              className="bg-[#141413] border-white/10 text-stone-200"
              required
            />
          </div>
          <div>
            <label className="text-stone-400 text-xs font-body uppercase tracking-wider mb-1.5 block">Passwort</label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort eingeben"
              className="bg-[#141413] border-white/10 text-stone-200"
              required
            />
          </div>

          {error && (
            <div data-testid="login-error" className="text-red-400 text-sm font-body bg-red-400/10 px-4 py-2 rounded-lg">
              {error}
            </div>
          )}

          <Button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-400 text-[#141413] font-semibold"
          >
            {loading ? <Loader2 size={16} className="animate-spin mr-2" /> : <Lock size={16} className="mr-2" />}
            Anmelden
          </Button>
        </form>

        <p className="text-center text-stone-700 text-xs font-body mt-6">
          <a href="/" className="hover:text-stone-500 transition-colors">Zurück zur Website</a>
        </p>
      </div>
    </div>
  );
}
